import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21943cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 3,
  class: "conversation-image-placeholder"
}
const _hoisted_6 = { class: "message-wrapper" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.conversation)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: `/inbox/${_ctx.conversation.id}`,
          class: "container"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isMessageUnread)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-circle-medium",
                      style: {"color":"red","padding":"1rem"}
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-circle-medium",
                      style: {"color":"green","padding":"1rem"}
                    })
                  ])),
              (_ctx.conversation.artwork && _ctx.conversation.artwork.image.thumbnail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: _ctx.conversation.artwork.image.thumbnail,
                    alt: _ctx.conversation.artwork.title
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, " Artwork does not exist "))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", {
                innerHTML: _ctx.conversation.html_title
              }, null, 8, _hoisted_7),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.conversation.last_message.participant.inbox_name) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.conversation.last_message.message), 1)
              ])
            ]),
            _createElementVNode("div", null, _toDisplayString(_ctx.formatDate()), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _hoisted_8
  ], 64))
}